export default "__VITE_PUBLIC_ASSET__0396abd3__"